module.exports = __webpack_public_path__ + "img/ziyouwangguo1.8a212c09.jpg";